import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../../core/services/maintenance.service';
import { Maintenance } from '../../core/models/maintenance.model';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { RouterModule } from '@angular/router';
import { TableComponent } from '../../shared/components/table/table.component';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from '../../shared/pipes/date-format.pipe';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { MaintenanceDetailComponent } from '../maintenance-detail/maintenance-detail.component';

@Component({
  selector: 'app-maintenance-list',
  templateUrl: './maintenance-list.component.html',
  styleUrls: ['./maintenance-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    RouterModule,
    NewButtonComponent,
    DateFormatPipe,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    ConfirmPopupComponent,
    MaintenanceDetailComponent,
  ],
})
export class MaintenanceListComponent implements OnInit {
  maintenances: Maintenance[] = [];
  flattenedData: any[] = [];
  maintenanceToDelete: Maintenance | null = null;
  selectedMaintenance: Maintenance | null = null; // Para la mantención seleccionada
  tableColumns: TableColumn[] = [
    { header: 'Id', field: 'id' },
    { header: 'Rol', field: 'roleName' },
    { header: 'Tipo de Mantención', field: 'maintenanceType' },
    { header: 'Tipo de Envase', field: 'containerTypeName' },
    { header: 'Estado', field: 'disabled' },
  ];

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit(): void {
    this.getMaintenances();
  }

  getMaintenances(): void {
    this.maintenanceService.getMaintenances().subscribe({
      next: (maintenances: Maintenance[]) => {
        this.maintenances = maintenances;
        this.flattenData();
      },
      error: error => {
        console.error('Error al obtener las mantenciones:', error);
      },
    });
  }

  flattenData(): void {
    this.flattenedData = this.maintenances.map((item: any) => ({
      id: item.id,
      roleName: item.rol?.roleName || '',
      maintenanceType: item.maintenanceType?.name || '',
      containerTypeName: item.containerType?.name,
      disabled: item.disabled,
    }));
  }

  confirmDelete(maintenance: Maintenance): void {
    this.maintenanceToDelete = maintenance;
  }

  onDeleteConfirm(): void {
    if (this.maintenanceToDelete && this.maintenanceToDelete.id !== undefined) {
      this.maintenanceService.deleteMaintenance(this.maintenanceToDelete.id).subscribe(() => {
        this.getMaintenances();
        this.maintenanceToDelete = null;
      });
    }
  }

  onDeleteCancel(): void {
    this.maintenanceToDelete = null;
  }

  toggleMaintenanceStatus(maintenance: Maintenance): void {
    maintenance.disabled = !maintenance.disabled;
    this.maintenanceService.disabledMaintenance(maintenance).subscribe(() => {
      this.getMaintenances();
    });
  }

  selectMaintenance(maintenance: Maintenance): void {
    this.selectedMaintenance = maintenance; // Asigna la mantención seleccionada
  }

  closeMaintenanceDetail(): void {
    this.selectedMaintenance = null; // Cierra el detalle de la mantención
  }
}
